import { type PasswordChangeFormValues } from "./type";

export const defaultValuesPasswordChange: PasswordChangeFormValues = {
  password: "",
  newPassword: "",
  confirmPassword: "",
};

export const passwordChangeButtonTestId =
  "pages/settings/account/change/password/__components__/password-change-form/PasswordChangeForm/Button-submit";
export const passwordChangeTypographyTitleTestId =
  "pages/settings/account/change/password/__components__/password-change-form/PasswordChangeForm/Typography-title";
export const passwordChangeTypographyDescriptionTestId =
  "pages/settings/account/change/password/__components__/password-change-form/PasswordChangeForm/Typography-description";
